import { getCustomerSiteMap, getCustomerSiteMapUnitStatuses } from "@/api/site_maps"
import { Controller } from "@hotwired/stimulus"
import { mount, unmount } from "svelte"

export default class extends Controller {
  static values = {
    siteMapId: String,
    topRightActionPath: String,
    topRightActionType: String,
  }

  // Loaded on demand so PixiJS stays out of the main bundle. The guard skips mounting if Turbo
  // disconnected the element mid-import, or if a quick reconnect already mounted it. Clearing the
  // element drops the stale copy of the previous mount that a Turbo cache restore brings back.
  async connect() {
    const { default: SiteMapViewer } = await import("@/components/site_map/SiteMapViewer.svelte")
    if (!this.element.isConnected || this.siteMapViewer) return

    this.element.replaceChildren()
    this.siteMapViewer = mount(SiteMapViewer, {
      props: {
        getSiteMap: getCustomerSiteMap,
        getUnitStatuses: getCustomerSiteMapUnitStatuses,
        isRestricted: true,
        siteMapId: this.siteMapIdValue,
        topRightActionPath: this.hasTopRightActionPathValue ? this.topRightActionPathValue : "",
        topRightActionType: this.hasTopRightActionTypeValue ? this.topRightActionTypeValue : "",
      },
      target: this.element,
    })
  }

  disconnect() {
    if (this.siteMapViewer) unmount(this.siteMapViewer)
    this.siteMapViewer = undefined
  }
}
